import Error from '../model/Error';
import SectionFederationEmployeeRelation from '../dto/SectionFederationEmployeeRelation';
import axios from 'axios';

export default class SectionFederationEmployeeRelationRepository {
    static findAll(federationEmployeeId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/federation-employees/${federationEmployeeId}/section-relations`)
                .then((response) => resolve(response.data.data.map((data) => SectionFederationEmployeeRelation.fromData(data))))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static create(federationEmployeeId, sectionId) {
        return new Promise((resolve, reject) => {
            axios
                .post('/section-federation-employee-relations', {
                    federationEmployeeId,
                    sectionId,
                })
                .then(() => resolve())
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static remove(sectionFederationEmployeeRelationId) {
        return new Promise((resolve, reject) => {
            axios
                .delete(`/section-federation-employee-relations/${sectionFederationEmployeeRelationId}`)
                .then(() => resolve())
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }
}
